(function () {
  'use strict';

  const CONFIG_ID = "LSCustomDildoNoSplitConfig";

  function readConfig() {
    const node = document.getElementById(CONFIG_ID);
    if (!node) return null;

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.error('[Love Smiths] Invalid custom dildo configuration:', error);
      return null;
    }
  }

  function init(config) {
    if (!config || !config.sectionId) return;

  /* ---------- Gallery fade swap ---------- */
  const thumbnails = document.querySelectorAll(".thumbnail");
  const mainBanner = document.getElementById("main-banner");
  function swapMainSrc(newSrc){
    if(!mainBanner||!newSrc) return;
    mainBanner.classList.add("is-fading");
    const img=new Image();
    img.onload=()=>{ 
      mainBanner.src=newSrc;
      mainBanner.srcset=newSrc; // force override
      mainBanner.removeAttribute("sizes"); // optional: let browser pick
      requestAnimationFrame(()=>mainBanner.classList.remove("is-fading")); 
    };
    img.onerror=()=>mainBanner.classList.remove("is-fading");
    img.src=newSrc;
  }
  thumbnails.forEach(t=>{
    t.addEventListener("click",function(){
      thumbnails.forEach(x=>x.classList.remove("selected"));
      this.classList.add("selected");
      swapMainSrc(this.getAttribute("data-large")||this.getAttribute("src"));
    });
      });
  /* --- Mobile swipe to change main image (uses swapMainSrc) --- */
(function () {
  // reuse existing variables from your script
  if (!mainBanner) return;

  const thumbs = Array.from(document.querySelectorAll(".thumbnail"));
  if (!thumbs.length) return;

  // start from currently selected thumbnail
  let currentIndex = Math.max(0, thumbs.findIndex(el => el.classList.contains("selected")));
  if (currentIndex === -1) currentIndex = 0;

  let startX = 0, startY = 0, swiping = false;

  function goTo(idx) {
    currentIndex = (idx + thumbs.length) % thumbs.length;
    const t = thumbs[currentIndex];
    thumbs.forEach(x => x.classList.remove("selected"));
    t.classList.add("selected");

    const newSrc = t.getAttribute("data-large") || t.getAttribute("src");
    // IMPORTANT: use your existing function so src, srcset, sizes, and fade are handled
    swapMainSrc(newSrc);
  }

  mainBanner.addEventListener("touchstart", (e) => {
    if (!e.touches || !e.touches.length) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    swiping = true;
  }, { passive: true });

  mainBanner.addEventListener("touchmove", (e) => {
    if (!swiping) return;
    const dx = e.touches[0].clientX - startX;
    const dy = e.touches[0].clientY - startY;
    // lock when horizontal intent is clear
    if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) {
      e.preventDefault();
    }
  }, { passive: false });

  mainBanner.addEventListener("touchend", (e) => {
    if (!swiping) return;
    swiping = false;

    const dx = e.changedTouches[0].clientX - startX;
    const dy = e.changedTouches[0].clientY - startY;

    // swipe threshold + horizontal dominance
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
      if (dx < 0) goTo(currentIndex + 1);   // swipe left → next
      else goTo(currentIndex - 1);          // swipe right → previous
    }
  });
})();


  /* ---------- Form elements ---------- */
  const form = document.getElementById(`product-form-${config.sectionId}`);
  if (!form) return;
  const hiddenInput = form.querySelector('input[name="id"]');
  const addToCartBtn = document.getElementById(`add-to-cart-${config.sectionId}`);
  const hint = document.getElementById(`selection-hint-${config.sectionId}`);
  const defaultHintText = hint ? hint.textContent.trim() : "";

function setCartVisibility(showButton, hintText = defaultHintText) {
  if (addToCartBtn) {
    addToCartBtn.style.visibility = showButton ? "visible" : "hidden";
    addToCartBtn.style.pointerEvents = showButton ? "auto" : "none";
  }

  if (hint) {
    hint.hidden = showButton;
    if (!showButton && hintText) {
      hint.textContent = hintText;
    }
  }
}

  const propFirmness = document.getElementById("prop-firmness");
  const propPour     = document.getElementById("prop-pour-style");

  // Generic colours (marble / 1-colour)
  const propC1 = document.getElementById("prop-colour-1");
  const propC2 = document.getElementById("prop-colour-2");
  const propC3 = document.getElementById("prop-colour-3");

  // Shade / area colours
  const propTip   = document.getElementById("prop-tip-colour");
  const propShaft = document.getElementById("prop-shaft-colour");
  const propBase  = document.getElementById("prop-base-colour");


  const variants = Array.isArray(config.variants) ? config.variants : [];
const availableVariants = (variants || []).filter(v => v && v.available);
  const optionBtns = form.querySelectorAll(".option-btn[data-variant='true']");
  const firmnessBtns = form.querySelectorAll(".btn-firmness");
  const pourBtns = form.querySelectorAll(".pour-style-btn");

  const customPanel = document.getElementById("customisation-panel");
  const swatchSetsContainer = document.getElementById("swatch-sets");
  const prototype = document.getElementById("swatch-prototype");
  const swatchSource = document.getElementById("swatch-source");
  const pourWrapper = document.getElementById("pour-style-wrapper");
  const livePreview = document.getElementById("live-preview");
  const instructionEl = document.getElementById("preview-instructions");

  /* ---------- Helpers ---------- */
  function slugify(val){
    return String(val||"").toLowerCase().trim().replace(/\s+/g,"-");
  }

  function canonicalSlugify(val) {
    return String(val || "")
      .toLowerCase()
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/ł/g, "l")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function arraysEqualCI(a,b){
    if(!a||!b||a.length!==b.length) return false;
    for(let i=0;i<a.length;i++){
      if(canonicalVariantValueByIndex(i, a[i]) !== canonicalVariantValueByIndex(i, b[i])) return false;
    }
    return true;
  }

  function getSelectedVariantOptions(){
    const selected = [];
    const activeButtons = Array.from(form.querySelectorAll('.option-btn[data-original-option].active'));
    (config.optionNames || []).forEach((optionName) => {
      const el = activeButtons.find((button) => button.dataset.originalOption === optionName);
      if (el) selected.push(el.dataset.value);
    });
    return selected;
  }

  function updateVariantId(){
    const selected = getSelectedVariantOptions();
    if (selected.length !== config.optionCount) {
      hiddenInput.value = "";
      return;
    }
    const match = variants.find(v=>arraysEqualCI(v.options, selected));
    hiddenInput.value = match ? match.id : "";
  }
/* ==============================
   DISABLE IMPOSSIBLE OPTION VALUES
   (prevents selecting non-existent variants)
============================== */
function getCurrentSelectionsByIndex() {
  const selected = Array(config.optionCount).fill(null);
  const activeButtons = Array.from(form.querySelectorAll('.option-btn[data-original-option].active'));

  (config.optionNames || []).forEach((optionName, optionIndex) => {
    const btn = activeButtons.find((button) => button.dataset.originalOption === optionName);
    if (btn) selected[optionIndex] = btn.dataset.value;
  });

  return selected;
}

function variantMatchesWithCandidate(variant, selections, candidateIndex, candidateValue) {
  if (!variant || !variant.options) return false;

  // Only earlier option groups constrain the candidate.
  // This keeps Size switchable and prevents Size/Base from disabling each other.
  for (let i = 0; i <= candidateIndex; i++) {
    const want = (i === candidateIndex) ? candidateValue : selections[i];
    if (!want) continue;

    const got = variant.options[i];
    if (canonicalVariantValueByIndex(i, got) !== canonicalVariantValueByIndex(i, want)) return false;
  }
  return true;
}

function isValueAvailableForIndex(optionIndex, value, selections) {
  return availableVariants.some(v => variantMatchesWithCandidate(v, selections, optionIndex, value));
}

function updateOptionAvailability() {
  const selections = getCurrentSelectionsByIndex();

  // For every variant button, compute whether it's still possible
  form.querySelectorAll('.option-btn[data-variant="true"]').forEach(btn => {
    const frame = btn.closest(".variant-frame");
    if (!frame) return;

    const optionIndex = parseInt(frame.getAttribute("data-option-index") || "", 10);
    if (Number.isNaN(optionIndex)) return;

    const value = btn.dataset.value;

    const ok = isValueAvailableForIndex(optionIndex, value, selections);

    // Disable impossible values
    btn.disabled = !ok;
    btn.classList.toggle("is-disabled", !ok);

    // If it was selected but is no longer possible, clear it
    if (!ok && btn.classList.contains("active")) {
      btn.classList.remove("active");
      btn.setAttribute("aria-pressed", "false");
    }
  });

  // After disabling, re-sync hidden variant id
  updateVariantId();
}
  function activePourStyle() {
    const btn = document.querySelector(".pour-style-btn.active");
    return btn ? btn.dataset.pourStyle : "";
  }

  function clearProperties(){
    propPour.value = "";
    propC1.value = ""; propC2.value = ""; propC3.value = "";
  }


  function getActiveColourCountButton() {
    return form.querySelector('.option-btn[data-option-group="colorcount"].active');
  }

  function isSurpriseColourButton(button) {
    if (!button) return false;
    const raw = String(button.dataset.value || button.textContent || "").trim();
    const canonical = canonicalSlugify(raw);

    // The Shopify value is "Surprise!". The no-number fallback also keeps
    // translated versions working while the other choices remain 1, 2 and 3.
    return canonical === "surprise" || !/\d/.test(raw);
  }

  function isSurpriseSelected() {
    return isSurpriseColourButton(getActiveColourCountButton());
  }

  function getSelectedColourCount() {
    const button = getActiveColourCountButton();
    if (!button || isSurpriseColourButton(button)) return 0;
    const match = String(button.dataset.value || button.textContent || "").match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  }

  function clearActiveButtons(selector) {
    form.querySelectorAll(selector).forEach(button => {
      button.classList.remove("active");
      button.setAttribute("aria-pressed", "false");
    });
  }

  function clearAllColourProperties() {
    clearProperties();
    if (propTip) propTip.value = "";
    if (propShaft) propShaft.value = "";
    if (propBase) propBase.value = "";
  }

  function resetDripState() {
    dripEnabled = false;
    dripColour = "";

    const dripNoButton = document.querySelector('.drip-toggle[data-value="no"]');
    const dripYesButton = document.querySelector('.drip-toggle[data-value="yes"]');

    if (dripNoButton) {
      dripNoButton.classList.add("active");
      dripNoButton.setAttribute("aria-pressed", "true");
    }
    if (dripYesButton) {
      dripYesButton.classList.remove("active");
      dripYesButton.setAttribute("aria-pressed", "false");
    }

    if (dripArea) dripArea.style.display = "none";
    if (dripHint) dripHint.style.display = "none";

    document.querySelectorAll("#drip-swatch-sets .swatch.active").forEach(swatch => {
      swatch.classList.remove("active");
      swatch.setAttribute("aria-pressed", "false");
    });

    document.querySelectorAll("#live-preview .preview-drip").forEach(node => node.remove());
  }

  function resetColourCustomisation(hidePanel = true) {
    clearActiveButtons(".pour-style-btn");
    clearAllColourProperties();
    resetDripState();

    if (swatchSetsContainer) swatchSetsContainer.innerHTML = "";
    if (pourWrapper) pourWrapper.style.display = "none";

    if (customPanel) customPanel.style.display = hidePanel ? "none" : "";
    if (instructionEl) instructionEl.textContent = window.customizerStrings.instr_start;
    updateLivePreview();
  }

  function applyColourCountSelection(button) {
    if (isSurpriseColourButton(button)) {
      // Surprise uses only the Shopify variant plus Size, Base and Firmness.
      // No pour style, swatches, split choices or drip add-on are required.
      resetColourCustomisation(true);
      return;
    }

    const count = getSelectedColourCount();
    if (customPanel) customPanel.style.display = "";
    renderSwatchSets(count, activePourStyle());
    updateLivePreview();
  }

  function syncCustomisationWithVariantSelection() {
    const countButton = getActiveColourCountButton();
    if (!countButton || isSurpriseColourButton(countButton)) {
      resetColourCustomisation(true);
    }
  }

  function addResetControl(frame, kind) {
    if (!frame || frame.querySelector(':scope > .ls-option-reset-btn')) return;

    const button = document.createElement("button");
    button.type = "button";
    button.className = "ls-option-reset-btn";
    button.dataset.resetKind = kind;
    button.textContent = window.customizerStrings.reset_selection || "Reset";
    button.hidden = true;

    frame.classList.add("ls-has-reset-control");
    frame.appendChild(button);
  }

  function installResetControls() {
    form.querySelectorAll('.variant-frame[data-option-index]').forEach(frame => {
      const optionButton = frame.querySelector('.option-btn[data-variant="true"][data-option-group]');
      if (optionButton) addResetControl(frame, optionButton.dataset.optionGroup);
    });

    addResetControl(document.getElementById("firmness-frame"), "firmness");
    addResetControl(pourWrapper, "pour-style");
    addResetControl(dripBlock, "drip");
  }

  function syncResetControls() {
    form.querySelectorAll(".ls-option-reset-btn").forEach(button => {
      const kind = button.dataset.resetKind;
      let selected = false;

      if (["size", "base", "colorcount"].includes(kind)) {
        selected = !!form.querySelector(`.option-btn[data-option-group="${kind}"].active`);
      } else if (kind === "firmness") {
        selected = !!propFirmness.value;
      } else if (kind === "pour-style") {
        selected = !!activePourStyle();
      } else if (kind === "drip") {
        selected = dripEnabled || !!dripColour;
      }

      button.hidden = !selected;
    });
  }

  function clearVariantGroup(group) {
    clearActiveButtons(`.option-btn[data-option-group="${group}"]`);
  }

  function resetByKind(kind) {
    if (kind === "size") {
      clearVariantGroup("size");
      clearVariantGroup("base");
      clearVariantGroup("colorcount");
      const sizePreview = document.getElementById("size-preview");
      const basePreview = document.getElementById("base-preview");
      if (sizePreview) sizePreview.innerHTML = "";
      if (basePreview) basePreview.innerHTML = "";
      resetColourCustomisation(true);
    } else if (kind === "base") {
      clearVariantGroup("base");
      clearVariantGroup("colorcount");
      const basePreview = document.getElementById("base-preview");
      if (basePreview) basePreview.innerHTML = "";
      resetColourCustomisation(true);
    } else if (kind === "colorcount") {
      clearVariantGroup("colorcount");
      resetColourCustomisation(true);
    } else if (kind === "firmness") {
      clearActiveButtons(".btn-firmness");
      propFirmness.value = "";
    } else if (kind === "pour-style") {
      clearActiveButtons(".pour-style-btn");
      clearAllColourProperties();
      if (swatchSetsContainer) swatchSetsContainer.innerHTML = "";
      updateLivePreview();
    } else if (kind === "drip") {
      resetDripState();
      updateLivePreview();
    }

    updateOptionAvailability();
    updatePricePartial();
    validate();
    syncResetControls();
  }

  function hydrateSwatches(root) {
    const rows = root.querySelectorAll(".swatch-row");
    rows.forEach(row => {
      const candidates = row.querySelectorAll(".swatch");
      candidates.forEach(el => {
        const img = el.querySelector("img");
        const name =
          el.dataset?.colourName ||
          (img ? img.alt : "") ||
          (el.textContent || "").trim();
        if(!name) return;
        el.classList.add("swatch");
        if(!el.dataset.colourName) el.dataset.colourName = name;
        el.setAttribute("role","button");
        if(!el.hasAttribute("aria-pressed")) el.setAttribute("aria-pressed","false");
      });
    });
  }

function makeSwatchSet(heading, maxSelect, role = "") {
  const clone = prototype.cloneNode(true);
  clone.style.display = "";
  const headingEl = clone.querySelector(".swatch-heading");
  headingEl.textContent = heading;
  clone.dataset.maxSelect = maxSelect;
  if (role) {
    clone.dataset.role = role;
    headingEl.dataset.role = role;
  }

  const row = clone.querySelector(".swatch-row");
  row.innerHTML = "";

  if (swatchSource) {
    // Try to find sub-category frames first
    let subCats = swatchSource.querySelectorAll(".sub-swatch-category");

    // Fallback: if snippet only has .swatch elements (no sub-categories)
    if (!subCats.length) subCats = swatchSource.querySelectorAll(".swatch");

    if (subCats.length) {
      subCats.forEach(cat => {
        const catClone = cat.cloneNode(true);
        row.appendChild(catClone);
      });
    } else {
      // Fallback — no categories at all, just a message
      const p = document.createElement("p");
      p.textContent = "No swatches available.";
      p.style.color = "#aaa";
      row.appendChild(p);
    }
  }

  hydrateSwatches(clone);
  return clone;
}

  function ensureCustomPanelVisible() {
    if (customPanel && customPanel.style.display === "none") {
      customPanel.style.display = "";
    }
  }

  /* ---------- FIXED Live Preview (clickable) ---------- */
function updateLivePreview() {
  if (!livePreview) return;

  const selectedImgs = swatchSetsContainer.querySelectorAll(".swatch.active img");
  const count = getSelectedColourCount();
  const style = activePourStyle();

  // Reset preview
  livePreview.innerHTML = "";
  const frag = document.createDocumentFragment();

  // Always remove any old drip preview
  livePreview.querySelectorAll(".preview-drip").forEach(d => d.remove());

  // Helper: make preview tile clickable -> scroll to the right swatch group
  function makePreviewClickable(wrapper) {
    wrapper.style.cursor = "pointer";

    wrapper.addEventListener("click", () => {
      const label = (wrapper.getAttribute("data-label") || "").toLowerCase();
      if (!label) return;

      const allSets = document.querySelectorAll("#swatch-sets .swatch-set");
      let targetSet = null;

      allSets.forEach(set => {
        const headingEl = set.querySelector(".swatch-heading");
        const heading = (headingEl ? headingEl.textContent : "").trim().toLowerCase();
        // we use "includes" so it works with translated headings too
        if (heading && label && heading.includes(label)) {
          targetSet = set;
        }
      });

      if (!targetSet) {
        targetSet = document.querySelector("#swatch-sets .swatch-set");
      }
      if (!targetSet) return;

      // expand that set if clamped
      if (window.expandSwatchSet) window.expandSwatchSet(targetSet);

      // scroll to first active swatch (or the set)
      const activeSwatch =
        targetSet.querySelector(".swatch.active") ||
        targetSet.querySelector(".swatch");

      const scrollTarget = activeSwatch || targetSet;
      scrollTarget.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      });
    });
  }

  // --- If no colours selected yet, show placeholder ---
  if (selectedImgs.length === 0) {
    const placeholder = document.createElement("div");
    placeholder.className = "preview-swatch";
    placeholder.innerHTML = `
      <img src="${config.placeholderUrl}"
           alt="${(window.customizerStrings && window.customizerStrings.preview_img_alt) || 'Live preview'}">
    `;
    frag.appendChild(placeholder);
  } else {
    // Build preview tiles from selected swatches
    selectedImgs.forEach((img) => {
      const wrapper = document.createElement("div");
      wrapper.className = "preview-swatch";

      const clone = img.cloneNode(true);
      wrapper.appendChild(clone);

      // Colour name overlay (bottom-right)
      const colourName = img.alt || "";
      if (colourName) {
        const nameTag = document.createElement("span");
        nameTag.className = "preview-colour-name";
        nameTag.textContent = colourName;
        wrapper.appendChild(nameTag);
      }

      // Work out which "area" this represents based on its set heading
      let labelText =
        (window.customizerStrings && window.customizerStrings.colour_generic) ||
        "colour";

      const set = img.closest(".swatch-set");
      if (set) {
        const headingEl = set.querySelector(".swatch-heading");
        const role = headingEl?.dataset?.role || "";
        const heading = (headingEl?.textContent || "").trim().toLowerCase();

        if (role === "tip" || heading.includes("tip") || heading.includes("spitze")) {
          labelText = (window.customizerStrings && window.customizerStrings.tip) || "tip";
        } else if (role === "shaft" || heading.includes("shaft") || heading.includes("schaft")) {
          labelText = (window.customizerStrings && window.customizerStrings.shaft) || "shaft";
        } else if (role === "base" || heading.includes("base") || heading.includes("basis")) {
          labelText = (window.customizerStrings && window.customizerStrings.base) || "base";
        }
      }

      wrapper.setAttribute("data-label", labelText.toLowerCase());
      makePreviewClickable(wrapper);

      frag.appendChild(wrapper);
    });
  }

  // --- Drip colour preview (click opens drip set) ---
  if (dripEnabled && dripColour) {
    const dripWrapper = document.createElement("div");
    dripWrapper.className = "preview-swatch preview-drip";

    const dripSwatchEl = document.querySelector("#drip-swatch-sets .swatch.active img");
    if (dripSwatchEl) {
      const dripImg = dripSwatchEl.cloneNode(true);
      dripWrapper.appendChild(dripImg);

      const dripName = dripImg.alt || dripColour || "";
      if (dripName) {
        const nameTag = document.createElement("span");
        nameTag.className = "preview-colour-name";
        nameTag.textContent = dripName;
        dripWrapper.appendChild(nameTag);
      }
    }

    const dripLabel =
      (window.customizerStrings && window.customizerStrings.drip_colour_label) ||
      "Drip";
    dripWrapper.setAttribute("data-label", dripLabel.toLowerCase());

    dripWrapper.style.cursor = "pointer";
    dripWrapper.addEventListener("click", () => {
      const dripSet = document.getElementById("drip-swatch-sets");
      if (!dripSet) return;
      if (window.expandSwatchSet) window.expandSwatchSet(dripSet);
      dripSet.scrollIntoView({ behavior: "smooth", block: "center" });
    });

    frag.appendChild(dripWrapper);
  }

  livePreview.appendChild(frag);
}


  /* ---------- Render swatch sets by count + style ---------- */
function renderSwatchSets(count, style) {
  ensureCustomPanelVisible();
  swatchSetsContainer.innerHTML = "";
  clearProperties();
  updateLivePreview();

  if (count === 1) {
    pourWrapper.style.display = "none";
    swatchSetsContainer.appendChild(makeSwatchSet(window.customizerStrings.swatch_choose_one, 1));
    return;
  }

  pourWrapper.style.display = "";
  if (!style) return;

  if (count === 2) {
    if (style === "ribbon-marble") {
      swatchSetsContainer.appendChild(makeSwatchSet(window.customizerStrings.swatch_choose_two_marble, 2));
    } else if (style === "ribbon-shade") {
      swatchSetsContainer.appendChild(makeSwatchSet(window.customizerStrings.swatch_tip, 1, "tip"));
      swatchSetsContainer.appendChild(makeSwatchSet(window.customizerStrings.swatch_base, 1, "base"));
    }
  }

  if (count === 3) {
    if (style === "ribbon-marble") {
      swatchSetsContainer.appendChild(makeSwatchSet(window.customizerStrings.swatch_choose_three_marble, 3));
    } else if (style === "ribbon-shade") {
      swatchSetsContainer.appendChild(makeSwatchSet(window.customizerStrings.swatch_tip, 1, "tip"));
      swatchSetsContainer.appendChild(makeSwatchSet(window.customizerStrings.swatch_shaft, 1, "shaft"));
      swatchSetsContainer.appendChild(makeSwatchSet(window.customizerStrings.swatch_base, 1, "base"));
    }
  }
  // after you append swatch sets (don’t remove existing code)
setTimeout(updateShadeAndGlow, 100);
}

  /* ---------- Validation ---------- */
  function validate() {
    const hasVariant  = !!hiddenInput.value;
    const hasFirmness = !!propFirmness.value;
    let coloursOk = false;
    let pourOk = true;

    const surpriseSelected = isSurpriseSelected();
    const count = getSelectedColourCount();
    const style = surpriseSelected ? "" : activePourStyle();

    // ---- Colour validation rules ----
    if (surpriseSelected) {
      coloursOk = true;
    } else if (count === 0) {
      coloursOk = true;
    } else if (count === 1) {
      coloursOk = swatchSetsContainer.querySelectorAll(".swatch.active").length === 1;
    } else if (count === 2) {
      if (!style) pourOk = false;
      coloursOk = swatchSetsContainer.querySelectorAll(".swatch.active").length === 2;
    } else if (count === 3) {
      if (!style) pourOk = false;
      coloursOk = swatchSetsContainer.querySelectorAll(".swatch.active").length === 3;
    }

    // ---- Save properties (firmness, pour style, colours) into hidden inputs ----
    if (hasVariant && hasFirmness) {
      propPour.value = (count > 1 && style) ? style : "";

      // Clear everything first
      if (propC1) propC1.value = "";
      if (propC2) propC2.value = "";
      if (propC3) propC3.value = "";
      if (propTip)   propTip.value   = "";
      if (propShaft) propShaft.value = "";
      if (propBase)  propBase.value  = "";

      const allSelected = [...swatchSetsContainer.querySelectorAll(".swatch.active")];

      const allNames = allSelected.map(sw =>
        sw.dataset.colourName || sw.querySelector("img")?.alt || ""
      );

      // Helper for shade: get set-by-index safely
      const sets = [...swatchSetsContainer.querySelectorAll(".swatch-set")];
      const getName = (setIndex) => {
        const set = sets[setIndex];
        if (!set) return "";
        const sw = set.querySelector(".swatch.active");
        if (!sw) return "";
        return (
          sw.dataset.colourName ||
          sw.querySelector("img")?.alt ||
          (sw.textContent || "").trim()
        );
      };

      // 1️⃣ No style / marble / single colour → just Colour 1/2/3
      if (!style || style === "ribbon-marble" || count <= 1) {
        if (propC1) propC1.value = allNames[0] || "";
        if (propC2) propC2.value = allNames[1] || "";
        if (propC3) propC3.value = allNames[2] || "";
      }

      // 2️⃣ Shade → Tip / (Shaft) / Base only
      else if (style === "ribbon-shade") {
        if (count === 2 && sets.length >= 2) {
          const tipName  = getName(0);
          const baseName = getName(1);

          propTip.value  = tipName  || "";
          propBase.value = baseName || "";
          // no shaft for 2-colour shade
          propShaft.value = "";
        }

        if (count === 3 && sets.length >= 3) {
          const tipName   = getName(0);
          const shaftName = getName(1);
          const baseName  = getName(2);

          propTip.value   = tipName   || "";
          propShaft.value = shaftName || "";
          propBase.value  = baseName  || "";
        }
      }
    }

    // ---- Button enabled? ----
    const ok = hasVariant && hasFirmness && pourOk && coloursOk;
addToCartBtn.disabled = !ok;

if (ok) {
  setCartVisibility(true);
} else if (!hasVariant) {
  setCartVisibility(false, window.customizerStrings.validation_choose_all);
} else if (!hasFirmness) {
  setCartVisibility(false, window.customizerStrings.validation_choose_firmness);
} else if (count > 1 && !style) {
  setCartVisibility(false, window.customizerStrings.validation_choose_pour_style);
} else {
  setCartVisibility(false, window.customizerStrings.validation_complete_colours);
}

    // ---- Instruction feedback ----
    if (instructionEl) {
      instructionEl.classList.remove("ready", "warning");
      hint.classList.remove("ready", "warning");

      if (!count) {
        instructionEl.textContent = window.customizerStrings.instr_start;
      } else if (count === 1) {
        instructionEl.textContent = coloursOk
          ? window.customizerStrings.instr_one_ready
          : window.customizerStrings.instr_one_pick;
        instructionEl.classList.add(coloursOk ? "ready" : "warning");
      } else if (count === 2) {
        if (!style) {
          instructionEl.textContent = window.customizerStrings.instr_two_choose_style;
          instructionEl.classList.add("warning");
        } else if (style === "ribbon-marble") {
          instructionEl.textContent = coloursOk
            ? window.customizerStrings.instr_two_marble_ready
            : window.customizerStrings.instr_two_marble_pick;
        } else if (style === "ribbon-shade") {
          instructionEl.textContent = coloursOk
            ? window.customizerStrings.instr_two_shade_ready
            : window.customizerStrings.instr_two_shade_pick;
        }
        instructionEl.classList.add(coloursOk ? "ready" : "warning");
      } else if (count === 3) {
        if (!style) {
          instructionEl.textContent = window.customizerStrings.instr_three_choose_style;
          instructionEl.classList.add("warning");
        } else if (style === "ribbon-marble") {
          instructionEl.textContent = coloursOk
            ? window.customizerStrings.instr_three_marble_ready
            : window.customizerStrings.instr_three_marble_pick;
        } else if (style === "ribbon-shade") {
          instructionEl.textContent = coloursOk
            ? window.customizerStrings.instr_three_shade_ready
            : window.customizerStrings.instr_three_shade_pick;
        }
        instructionEl.classList.add(coloursOk ? "ready" : "warning");
      }
    }

    // If drip is enabled, require one drip colour
    if (!surpriseSelected && dripBlock && dripBlock.style.display !== "none" && dripEnabled) {
  const hasDripColour = !!dripColour;
  if (!hasDripColour) {
    addToCartBtn.disabled = true;
    setCartVisibility(
      false,
      (window.customizerStrings && window.customizerStrings.pick_one_colour) ||
      "Pick one colour for the drip."
    );
  }
}
  }


  /* ---------- Event bindings ---------- */
function normalizeOptionName(name) {
  if (!name) return "";
  const lower = name.toLowerCase().trim();

  /* ============================================
     SIZE  — European languages + Japanese
     ============================================ */
  const sizeWords = [
    // English
    "size",
    // French
    "taille",
    // Spanish
    "tamaño",
    // Portuguese
    "tamanho",
    // Italian
    "misura",
    // German
    "größe", "groesse", "grosse",
    // Dutch
    "maat",
    // Danish / Norwegian
    "størrelse", "storrelse",
    // Swedish
    "storlek",
    // Finnish
    "koko",
    // Polish
    "rozmiar",
    // Czech / Slovak
    "velikost",
    // Hungarian
    "méret", "meret",
    // Romanian
    "mărime", "marime",
    // Greek
    "μέγεθος", "megethos",
    // Bulgarian
    "размер", "razmer",
    // Croatian / Serbian / Bosnian / Slovene
    "veličina", "velicina",
    // Lithuanian
    "dydis",
    // Latvian
    "izmērs", "izmēri", "izmers",
    // Estonian
    "suurus",
    // Japanese
    "サイズ", "さいず", "寸法", "大きさ"
  ];

  if (sizeWords.includes(lower)) return "size";

  /* ============================================
     BASE — European languages + Japanese
     ============================================ */
  const baseWords = [
    // English
    "base",
    // French
    "fond", "base",
    // Spanish / Portuguese
    "base",
    // Italian
    "base",
    // German
    "basis", "sockel",
    // Dutch
    "basis",
    // Nordic
    "base", "bunn", "botten", "bas",
    // Finnish
    "pohja",
    // Polish
    "podstawa",
    // Czech / Slovak
    "základ", "zaklad", "spodek",
    // Hungarian
    "alap",
    // Romanian
    "bază", "baza",
    // Greek
    "βάση", "vasi",
    // Bulgarian
    "основа", "osnova",
    // Croatian / Serbian / Slovene
    "baza",
    // Baltic
    "pamata", "pamats", "põhi",
    // Japanese
    "ベース", "べーす", "台座", "基部"
  ];

  if (baseWords.includes(lower)) return "base";


  /* ======================================================
     HOW MANY COLOURS? — European languages + Japanese
     ====================================================== */

  // Detect the *question* part
  const howManyWords = [
    "how many", "how many colours", "how many colors",
    "hoeveel", "hoeveel kleuren",
    "combien", "combien de couleurs",
    "cuántos", "cuantos", "cuántos colores",
    "quantas cores", "quantos cores", "quantos colores",
    "quante", "quanti colori",
    "wie viele", "wieviele farben",
    "hvor mange farver",
    "hur många färger",
    "hvor mange farger",
    "kuinka monta väriä",
    "ile kolorów", "ile kolorow",
    "kolik barev",
    "koliko boja",
    "koliko barv",
    "câte culori", "cate culori",
    "πόσα χρώματα", "posa hromata",
    "колко цвята", "kolko cvyata",
    // Japanese
    "何色", "なんしょく", "いくつの色", "カラー数", "カラー数は？"
  ];

  // Detect "colour" itself
  const colourWords = [
    "colour", "color", "couleur", "colores", "colours", "cores",
    "farben", "farver", "färger", "farger", "väriä", "barvy",
    "boje", "barve", "culori", "kleur", "kleuren", "χρώματα", "цвета", "カラー", "色"
  ];

  const hasHowMany = howManyWords.some(w => lower.includes(w));
  const hasColour = colourWords.some(w => lower.includes(w));

  if (hasHowMany && hasColour) return "colorcount";

  /* fallback: return cleaned lower string */
  return lower;
}

const canonicalValueMap = {
  size: {
    // already slugs or single words – OK as-is
    "cute": "cute",
    "schattig": "cute",
    "uroczy": "cute",
    "slodki": "cute",
    "sliczny": "cute",
    "mignon": "cute",
    "lindo": "cute",
    "mignon(ne)": "cute",          // slugify → "mignon(ne)"
    "bonito": "cute",
    "sizeless": "cute",
    "söt": "cute",
"sot": "cute",
"herkulisk": "herculean",
"mammut": "mammoth",
"gigantisk": "gargantuan",

    "herculean": "herculean",
    "herkulisch": "herculean",
    "herkulesowy": "herculean",
    "herculeen": "herculean",
    "hercúleo": "herculean",
    "herculéen": "herculean",
    "herkulisch": "herculean",
    "ヘルキュリン": "herculean",

    "mammoth": "mammoth",
    "mammoet": "mammoth",
    "mamút": "mammoth",
    "mamut": "mammoth",
    "mammut": "mammoth",
    "マンモス": "mammoth",

    "gargantuan": "gargantuan",
    "gigantisch": "gargantuan",
    "gigantyczny": "gargantuan",
    "gargantuiczny": "gargantuan",
    "ogromny": "gargantuan",
    "olbrzymi": "gargantuan",
    "gargantuesque": "gargantuan",
    "gargantuesco": "gargantuan",
    "riesig": "gargantuan",
    "ガルガンチュアン": "gargantuan"
  },

  base: {
    // FLAT
    "flat": "flat",
    "plaska": "flat",
    "plaski": "flat",
    "flach": "flat",
    "plat": "flat",
    "plate": "flat",
    "plana": "flat",
    "departamento": "flat",
    "llano": "flat",
    "フラット": "flat",
    "platt": "flat",

    // SUCTION CUP
    "suction-cup": "suction-cup",    // English option already slug
    "met-zuignap": "suction-cup",
    "met zuignap": "suction-cup",
    "z-przyssawka": "suction-cup",
    "przyssawka": "suction-cup",
    "saugnapf": "suction-cup",
    "ventouse": "suction-cup",
    "ventosa": "suction-cup",
    "吸盤": "suction-cup",
    "sugkopp": "suction-cup",

    // PLUG-COMPATIBLE — all keys must be SLUGS (with dashes)
    "plug-compatible": "plug-compatible",              // English
    "plug-compatibel": "plug-compatible",
    "kompatybilna-z-korkiem": "plug-compatible",
    "kompatybilna-z-korkiem-analnym": "plug-compatible",
    "kompatybilna-z-plugiem": "plug-compatible",
    "kompatybilny-z-korkiem": "plug-compatible",
    "pluggkompatibel": "plug-compatible",
    "kompatybilny-z-korkiem-analnym": "plug-compatible",
    "plug-kompatibel": "plug-compatible",             // German
    "compatible-avec-les-prises": "plug-compatible",   // “compatible avec les prises”
    "compatible-avec-les-prise": "plug-compatible",    // if typo / singular
    "compatible-avec-prise": "plug-compatible",
    "compatible-avec-prises": "plug-compatible",
    "compatible-con-plug": "plug-compatible",
    "compatible-con-enchufes": "plug-compatible",      // ES: compatible con enchufes
    "compatible-con-enchufe": "plug-compatible",       // singular
    "compatible-con-enchufes-y-mas": "plug-compatible",// in case translator adds bits

    "compatible-plug": "plug-compatible",              // already a slug
    "compatible-plug-in": "plug-compatible",

    "プラグ対応": "plug-compatible",                      // Japanese
    "compatible-avec-plug": "plug-compatible"
  }
};

function canonicalVariantValueByIndex(index, value) {
  const optionName = (config.optionNames && config.optionNames[index]) || "";
  const norm = normalizeOptionName(optionName);
  const rawValue = slugify(value);
  const canonicalRawValue = canonicalSlugify(value);
  const map = canonicalValueMap[norm] || {};
  const mappedValue = map[rawValue] || map[canonicalRawValue];

  if (mappedValue) return mappedValue;

  if (norm === "base") {
    if (canonicalRawValue.includes("przyssawka") || canonicalRawValue.includes("zuignap")) return "suction-cup";
    if (canonicalRawValue.includes("plaska") || canonicalRawValue === "plat") return "flat";
    if (canonicalRawValue.includes("korkiem") || canonicalRawValue.includes("plug") || canonicalRawValue.includes("compatibel")) return "plug-compatible";
  }

  if (norm === "size") {
    if (canonicalRawValue.includes("herkul")) return "herculean";
    if (canonicalRawValue.includes("mamut") || canonicalRawValue.includes("mammoet")) return "mammoth";
    if (canonicalRawValue.includes("gigant") || canonicalRawValue.includes("gargant") || canonicalRawValue.includes("ogrom") || canonicalRawValue.includes("olbrzym")) return "gargantuan";
    if (canonicalRawValue.includes("urocz") || canonicalRawValue.includes("slodk") || canonicalRawValue.includes("sliczn") || canonicalRawValue.includes("schattig")) return "cute";
  }

  return canonicalRawValue || rawValue || String(value || "").toLowerCase().trim();
}



optionBtns.forEach(btn=>{
  btn.addEventListener("click", function(){
    const group = this.getAttribute("data-option-group");
    form.querySelectorAll(`.option-btn[data-option-group="${group}"]`)
      .forEach(b=>{ b.classList.remove("active"); b.setAttribute("aria-pressed","false"); });
    this.classList.add("active");
    this.setAttribute("aria-pressed","true");

    const og = this.getAttribute("data-original-option");
    const val = slugify(this.dataset.value);
    const handle = slugify(config.productHandle);

    const norm = normalizeOptionName(og);

// === Language-proof preview key ===
if (norm === "size" || norm === "base") {
  const rawValue = slugify(this.dataset.value); // translated text
  const canonicalRawValue = canonicalSlugify(this.dataset.value);
  const canonical = canonicalValueMap[norm][rawValue] || canonicalValueMap[norm][canonicalRawValue] || canonicalRawValue || rawValue;

  const key = `${handle}_${norm}_${canonical}`;
  const preview = document.getElementById(`${norm}-preview`);

  if (preview) {
    const src = window.variantImages[key];
    preview.innerHTML = src
      ? `<img src="${src}" width="280" height="280" alt="${norm} preview">`
      : "";
  }
}


    // Special handling for colour count, including the Shopify Surprise! variant.
    if (group === "colorcount" || norm === "colorcount") {
      applyColourCountSelection(this);
    }

updateOptionAvailability();
syncCustomisationWithVariantSelection();
updatePricePartial();
validate();
  });
});

  firmnessBtns.forEach(btn=>{
    btn.addEventListener("click", function(){
      firmnessBtns.forEach(b=>{ b.classList.remove("active"); b.setAttribute("aria-pressed","false"); });
      this.classList.add("active");
      this.setAttribute("aria-pressed","true");
      propFirmness.value = this.dataset.value || "";
      validate();
    });
  });

  pourBtns.forEach(btn=>{
    btn.addEventListener("click", function(){
      pourBtns.forEach(b=>{ b.classList.remove("active"); b.setAttribute("aria-pressed","false"); });
      this.classList.add("active");
      this.setAttribute("aria-pressed","true");
      const countBtn = getActiveColourCountButton();
      if (countBtn && !isSurpriseColourButton(countBtn)) {
        renderSwatchSets(getSelectedColourCount(), this.dataset.pourStyle);
      }
      validate();
    });
  });

  swatchSetsContainer.addEventListener("click", function(e){
    const sw = e.target.closest(".swatch");
    if (!sw) return;
    const setEl = sw.closest(".swatch-set");
    if (!setEl) return;

    const max = parseInt(setEl.dataset.maxSelect||"1",10);
    if (sw.classList.contains("active")) {
      sw.classList.remove("active"); sw.setAttribute("aria-pressed","false");
    } else {
      if (max===1) {
        setEl.querySelectorAll(".swatch.active").forEach(b=>{
          b.classList.remove("active"); b.setAttribute("aria-pressed","false");
        });
      }
      if (setEl.querySelectorAll(".swatch.active").length < max) {
        sw.classList.add("active"); sw.setAttribute("aria-pressed","true");
      }
    }
    updateLivePreview();
    validate();
    // ✅ auto-collapse when selection complete
const maxSel = parseInt(setEl.dataset.maxSelect || "1", 10);
const chosen = setEl.querySelectorAll(".swatch.active").length;
if (chosen >= maxSel && window.collapseSwatchSet) {
  setTimeout(() => window.collapseSwatchSet(setEl), 300); // small delay feels smoother
}
// Smoothly scroll back to the same swatch's "Show colours" button
setTimeout(() => {
  const btn = setEl.querySelector(".show-more-swatches");
  if (btn) {
    btn.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}, 500);

  });

  /* Variant More Information accordion (incl. pour-style example) */
  document.addEventListener("click", function(e) {
    const btn = e.target.closest(".variant-more-info-btn");
    if (!btn) return;
    const key = btn.dataset.info;
    const target = document.querySelector(`.variant-more-info-content[data-info-target="${key}"]`);
    if (!target) return;

    const isOpen = target.classList.contains("open");

    // Reset all sections
    document.querySelectorAll(".variant-more-info-content").forEach(section => {
      section.classList.remove("open");
    });
    document.querySelectorAll(".variant-more-info-btn").forEach(b => {
      const isExampleButton = b.dataset.info === "pour-style" || b.dataset.info === "drip-effect-example";

      if (isExampleButton) {
        b.textContent = window.customizerStrings.pour_show_example;
      } else {
        b.textContent = window.customizerStrings.more_info;
      }
      b.setAttribute("aria-expanded", "false");
    });

    // Open the one clicked (if not already open)
    if (!isOpen) {
      target.classList.add("open");
      const isExampleButton = btn.dataset.info === "pour-style" || btn.dataset.info === "drip-effect-example";

      if (isExampleButton) {
        btn.textContent = window.customizerStrings.pour_hide_example;
      } else {
        btn.textContent = window.customizerStrings.hide_info;
      }
      btn.setAttribute("aria-expanded", "true");
    }
  });
/* ==============================
   DYNAMIC PRICE UPDATE
============================== */
function updatePricePartial() {
  const priceEls = document.querySelectorAll(".sticky-cart-price");
  const selected = getSelectedVariantOptions();

  const currentCurrency = config.currency;
  const currentLocale = config.locale;

  function formatComputedMoney(amount) {
    return new Intl.NumberFormat(currentLocale, {
      style: "currency",
      currency: currentCurrency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount / 100);
  }

  // no selection yet
  if (!selected.length) {
    priceEls.forEach(el => el.textContent = "");
    return;
  }

  const partial = variants.find(v =>
    selected.every(sel =>
      v.options.some((o, index) => canonicalVariantValueByIndex(index, o) === canonicalVariantValueByIndex(index, sel))
    )
  );

  if (!partial) return;

  const basePrice = Number(partial.price || 0);
  const dripPrice =
    (window.dripAddon && dripEnabled && window.dripAddon.variant_price)
      ? Number(window.dripAddon.variant_price)
      : 0;

  const total = basePrice + dripPrice;

  let html = "";
  if (
    partial.formatted_compare_at_price &&
    Number(partial.compare_at_price) > Number(partial.price)
  ) {
    html = `
      <span class="price--compare"><s>${partial.formatted_compare_at_price}</s></span>
      <span class="price--sale">${partial.formatted_price}</span>
    `;
  } else {
    html = partial.formatted_price || "";
  }

  if (dripPrice > 0) {
    const dripPriceLabel = window.customizerStrings?.drip_price_label || "Drip";
    const totalLabel = window.customizerStrings?.total_label || "Total";

    html += `
      <span class="ls-drip-price-addition">+ ${window.dripAddon.formatted_variant_price || formatComputedMoney(dripPrice)} (${dripPriceLabel})</span>
      <strong class="ls-price-total">${totalLabel}: ${formatComputedMoney(total)}</strong>
    `;
  }

  priceEls.forEach(el => {
    el.innerHTML = html;
  });
}
/* ========== CASCADING SHADE LOGIC + GLOW RESTRICTION ========== */
function updateShadeAndGlow() {
  const allSets = [...swatchSetsContainer.querySelectorAll(".swatch-set")];

  const findSet = (role) => allSets.find(set => {
    const h = set.querySelector(".swatch-heading");
    return set.dataset.role === role || h?.dataset?.role === role;
  });

  const tipSet   = findSet("tip");
  const shaftSet = findSet("shaft");
  const baseSet  = findSet("base");

  const tipChosen   = !!(tipSet && tipSet.querySelector(".swatch.active"));
  const shaftChosen = !!(shaftSet && shaftSet.querySelector(".swatch.active"));

  const tipGlow   = !!(tipSet && tipSet.querySelector(".swatch.active[data-colour-type='Glow']"));
  const shaftGlow = !!(shaftSet && shaftSet.querySelector(".swatch.active[data-colour-type='Glow']"));

  const pourStyle = activePourStyle();
  const colourCount = getSelectedColourCount();

  // remove previous helper messages
  document.querySelectorAll(".glow-helper-msg").forEach(m => m.remove());

  const addMsg = (setEl, msg) => {
    if (!setEl) return;
    const note = document.createElement("p");
    note.className = "glow-helper-msg";
    note.textContent = msg;
    note.style.color = "#f5c77d";
    note.style.fontSize = "0.9rem";
    note.style.textAlign = "center";
    note.style.margin = "0.5rem 0";
    const clampWrap = setEl.querySelector(".clamp-wrap");
if (clampWrap) {
  clampWrap.appendChild(note); // put inside collapsible area at bottom
} else {
  setEl.appendChild(note); // fallback if no clamp
}

  };

  // Hide all to start
  [shaftSet, baseSet].forEach(set => { if (set) set.style.display = "none"; });

  // Reset Glow visibility
  allSets.forEach(set => {
    set.querySelectorAll(".swatch[data-colour-type='Glow']").forEach(sw => sw.style.display = "");
  });

  /* === 2-COLOUR SHADE === */
  if (pourStyle === "ribbon-shade" && colourCount === 2) {
    if (tipChosen && baseSet) {
      baseSet.style.display = ""; // reveal base only after tip chosen
      // hide base glow until tip glow chosen
      const baseGlows = baseSet.querySelectorAll(".swatch[data-colour-type='Glow']");
      if (!tipGlow) {
        baseGlows.forEach(sw => sw.style.display = "none");
        addMsg(baseSet, window.customizerStrings.glow_msg_select_tip || "Select Glow in the Tip first to unlock Glow for the Base.");
      }
    }
  }

  /* === 3-COLOUR SHADE === */
  if (pourStyle === "ribbon-shade" && colourCount === 3) {
    if (tipChosen && shaftSet) {
      shaftSet.style.display = ""; // show shaft after tip
      const shaftGlows = shaftSet.querySelectorAll(".swatch[data-colour-type='Glow']");
      if (!tipGlow) {
        shaftGlows.forEach(sw => sw.style.display = "none");
        addMsg(shaftSet, window.customizerStrings.glow_msg_select_tip || "Select Glow in the Tip first to unlock Glow for the Shaft.");
      }
    }
    if (shaftChosen && baseSet) {
      baseSet.style.display = ""; // show base after shaft
      const baseGlows = baseSet.querySelectorAll(".swatch[data-colour-type='Glow']");
      if (!shaftGlow) {
        baseGlows.forEach(sw => sw.style.display = "none");
        addMsg(baseSet, window.customizerStrings.glow_msg_select_shaft || "Select Glow in the Shaft first to unlock Glow for the Base.");
      }
    }
  }

  // Hide whole glow category if nothing visible
  allSets.forEach(set => {
    const hasVisibleGlow = !!set.querySelector(".swatch[data-colour-type='Glow']:not([style*='display: none'])");
    const glowCat = set.querySelector(".sub-swatch-category.glow");
    if (glowCat) glowCat.style.display = hasVisibleGlow ? "" : "none";
  });
}

/* --- Hook --- */
swatchSetsContainer.addEventListener("click", (e) => {
  if (e.target.closest(".swatch")) {
    setTimeout(updateShadeAndGlow, 150);
  }
});


// Listen for all swatch selections
swatchSetsContainer.addEventListener("click", (e) => {
  if (!e.target.closest(".swatch")) return;
  setTimeout(updateGlowAvailability, 150);
});

form.addEventListener("click", () => {
  window.setTimeout(syncResetControls, 0);
});

// === DRIP ADD-ON STATE ===
const dripBlock = document.getElementById("drip-addon-block");
const dripArea = document.getElementById("drip-swatch-area");
const dripHint = document.getElementById("drip-colour-hint");
let dripEnabled = false;           
let dripColour = "";               
let dripVariantId = (window.dripAddon && window.dripAddon.variant_id) || null;

// Build drip UI if configured
if (window.dripAddon && window.dripAddon.enabled && dripVariantId && dripBlock) {
  dripBlock.style.display = "";

  // --- Hydrate swatches (from hidden source) ---
  const dripRoot = document.getElementById("drip-swatch-source");
  const dripRow = document.querySelector("#drip-swatch-sets .swatch-row");
  if (dripRoot && dripRow) {
    // Clone the swatches from the hidden drip source
    const sourceGroup = dripRoot.querySelector(".swatch-groups");
    if (sourceGroup) {
      dripRow.innerHTML = sourceGroup.innerHTML;
      hydrateSwatches(dripRow);
    }
  }

// --- Toggle buttons (Yes/No) ---
const dripToggles = Array.from(document.querySelectorAll(".drip-toggle"));
dripToggles.forEach(btn => {
  btn.addEventListener("click", () => {
    // reset buttons
    dripToggles.forEach(b => {
      b.classList.remove("active");
      b.setAttribute("aria-pressed", "false");
    });
    btn.classList.add("active");
    btn.setAttribute("aria-pressed", "true");

    // ✅ update flag + show / hide area
    dripEnabled = btn.dataset.value === "yes";
    dripArea.style.display = dripEnabled ? "" : "none";
    if (dripHint) dripHint.style.display = dripEnabled ? "" : "none";

    if (!dripEnabled) {
      // clear drip data + remove preview instantly
      dripColour = "";
      document
        .querySelectorAll("#drip-swatch-sets .swatch.active")
        .forEach(s => {
          s.classList.remove("active");
          s.setAttribute("aria-pressed", "false");
        });
      document
        .querySelectorAll("#live-preview .preview-drip")
        .forEach(el => el.remove());
    }

    // re-sync UI
    updateLivePreview();
    updatePricePartial();
    validate();
  });
});

  // --- Swatch click listener (visible area) ---
  const dripVisibleSet = document.getElementById("drip-swatch-sets");
  if (dripVisibleSet) {
    dripVisibleSet.addEventListener("click", (e) => {
      const sw = e.target.closest(".swatch");
      if (!sw) return;

      // single select behaviour
      dripVisibleSet.querySelectorAll(".swatch.active").forEach(s => {
        s.classList.remove("active");
        s.setAttribute("aria-pressed", "false");
      });

      sw.classList.add("active");
      sw.setAttribute("aria-pressed", "true");

      dripColour = sw.dataset.colourName || sw.querySelector("img")?.alt || "";
      updateLivePreview(); // refresh preview when drip colour chosen
      validate(); // recheck readiness to add to cart
      updatePricePartial(); // ✅ refresh sticky price after drip colour chosen
      // ✅ collapse drip set after 1 selection
if (window.collapseSwatchSet) {
  setTimeout(() => window.collapseSwatchSet(dripVisibleSet), 300);
}
// Smoothly scroll back to the drip "Show colours" button
setTimeout(() => {
  const btn = dripVisibleSet.querySelector(".show-more-swatches");
  if (btn) {
    btn.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}, 500);

    });
  }
}
// === MULTI-ADD SUBMIT (handles cart properties for Shade vs Marble) ===
form.addEventListener("submit", async (e) => {
  const wantDrip =
    dripBlock &&
    dripBlock.style.display !== "none" &&
    dripEnabled &&
    dripVariantId;

  // If NO drip, let Shopify handle the normal form
  if (!wantDrip) {
    return;
  }

  // With drip we intercept and send both items through the cart add route.
  e.preventDefault();

  if (!hiddenInput.value) return; // safety
  addToCartBtn.disabled = true;

  // ---------- Helpers ----------
  function getColourCount() {
    const btn = form.querySelector('.option-btn[data-option-group="colorcount"].active');
    if (!btn) return 0;
    const raw = btn.dataset.value || btn.textContent || "";
    const m = raw.match(/\d+/);
    return m ? parseInt(m[0], 10) : 0;
  }
  function getStyle() {
    return activePourStyle() || "";
  }
  function getSwatchSets() {
    return Array.prototype.slice.call(
      swatchSetsContainer.querySelectorAll(".swatch-set")
    );
  }
  function getSwatchName(sw) {
    if (!sw) return "";
    if (sw.dataset && sw.dataset.colourName) return sw.dataset.colourName;
    const img = sw.querySelector("img");
    if (img && img.alt) return img.alt;
    return (sw.textContent || "").trim();
  }

  const colourCount = getColourCount();
  const style = getStyle();
  const sets = getSwatchSets();

  // collect all active swatches (DOM order)
  const allActiveSwatches = [];
  sets.forEach(set => {
    set.querySelectorAll(".swatch.active").forEach(sw => allActiveSwatches.push(sw));
  });

  // ---------- Build main product properties ----------
  const props = {};

  // firmness / pour style
  if (propFirmness && propFirmness.value) {
    props[config.strings.firmnessLabel] = propFirmness.value;
  }
  if (propPour && propPour.value) {
    props[config.strings.pourStyleLabel] = propPour.value;
  }

  // Helper: generic colours 1 / 2 / 3
  function setGenericColoursFrom(swArray) {
    const names = swArray.map(getSwatchName).filter(Boolean);
    if (names[0]) props[config.strings.colour1] = names[0];
    if (names[1]) props[config.strings.colour2] = names[1];
    if (names[2]) props[config.strings.colour3] = names[2];
  }

  // Helper: shade areas by position (0 = tip, 1 = shaft, 2 = base)
  function getShadeNameByIndex(idx) {
    const set = sets[idx];
    if (!set) return "";
    const sw = set.querySelector(".swatch.active");
    return getSwatchName(sw);
  }

  // Decide how to store colours for the main product
  if (colourCount <= 1 || !style || style === "ribbon-marble") {
    // 1 colour or marble → Colour 1/2/3 only
    setGenericColoursFrom(allActiveSwatches);
  } else if (style === "ribbon-shade") {
    // Shade → Tip / Shaft / Base only (no generic Colour 1/2/3)
    if (colourCount === 2 && sets.length >= 2) {
      const tipName  = getShadeNameByIndex(0);
      const baseName = getShadeNameByIndex(1);

      if (tipName) {
        props[config.strings.cartTipColour] = tipName;
      }
      if (baseName) {
        props[config.strings.cartBaseColour] = baseName;
      }
    }

    if (colourCount === 3 && sets.length >= 3) {
      const tipName   = getShadeNameByIndex(0);
      const shaftName = getShadeNameByIndex(1);
      const baseName  = getShadeNameByIndex(2);

      if (tipName) {
        props[config.strings.cartTipColour] = tipName;
      }
      if (shaftName) {
        props[config.strings.cartShaftColour] = shaftName;
      }
      if (baseName) {
        props[config.strings.cartBaseColour] = baseName;
      }
    }
  } else {
    // Unknown style (fallback)
    setGenericColoursFrom(allActiveSwatches);
  }

  // ---------- Drip linkage ----------
  // Generate a unique reference so the drip add-on can always be matched
  // to the correct custom dildo in the cart and Shopify order.
  let dripReference = "";

  if (window.crypto && typeof window.crypto.randomUUID === "function") {
    dripReference = `DRIP-${window.crypto
      .randomUUID()
      .replace(/-/g, "")
      .slice(0, 6)
      .toUpperCase()}`;
  } else {
    dripReference = `DRIP-${Date.now()
      .toString(36)
      .slice(-6)
      .toUpperCase()}`;
  }

  // Visible on the custom dildo.
  props[config.strings.dripReferenceLabel] = dripReference;

  // Hidden internal linkage retained in Shopify order data.
  props._drip_reference = dripReference;

  // ---------- Drip properties ----------
  const dripProps = {
    [config.strings.dripForLabel]: dripReference,
    _drip_reference: dripReference
  };

  if (dripColour) {
    dripProps[config.strings.dripColourLabel] = dripColour;
  }

  // ---------- Send both items to cart ----------
  try {
    if (!window.LSAjaxCart || typeof window.LSAjaxCart.addItems !== "function") {
      throw new Error("Cart drawer is unavailable");
    }

    await window.LSAjaxCart.addItems(
      [
        {
          id: Number(hiddenInput.value),
          quantity: 1,
          properties: props
        },
        {
          id: Number(dripVariantId),
          quantity: 1,
          properties: dripProps
        }
      ],
      {
        open: true,
        trigger: addToCartBtn,
        source: "ls-custom-builder-drip"
      }
    );

    addToCartBtn.disabled = false;
  } catch (err) {
    console.error(err);
    addToCartBtn.disabled = false;
    hint.hidden = false;
    hint.textContent = config.strings.cartError;
  }
});


form.addEventListener("click", event => {
  const resetButton = event.target.closest(".ls-option-reset-btn");
  if (!resetButton) return;
  resetByKind(resetButton.dataset.resetKind || "");
});


hiddenInput.value = "";
addToCartBtn.disabled = true;
setCartVisibility(false);
updateOptionAvailability();
validate();
syncResetControls();

  }

  function boot() {
    init(readConfig());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
